'use client';

import type { Route } from 'next';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

export interface RouterPush {
	(pathname: string, queryParams?: Record<string, string | undefined | null>): void;
}

export function useRouterPush() {
	const router = useRouter();
	const currentParams = useSearchParams();

	return useCallback(
		(pathname: string, queryParams: Record<string, string | undefined | null> = {}) => {
			const params = new URLSearchParams(currentParams?.toString());

			// Merge new params
			Object.entries(queryParams).forEach(([key, value]) => {
				if (value === undefined || value === null) {
					params.delete(key);
				} else {
					params.set(key, value);
				}
			});

			const queryString = params.toString();
			const url = queryString ? `${pathname}?${queryString}` : pathname;
			return router.push(url as Route);
		},
		[router, currentParams],
	);
}
